module.exports = __webpack_public_path__ + "img/retrofit-details-1.6771ee45.png";